<template>
    <v-tooltip bottom :disabled="!obj.schema.disabled" open-on-hover content-class="myprovet-tooltip">
        <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
                <v-select v-bind="{ ...obj.schema }" v-on:input="onUpdate($event)" :value="value"> </v-select>
            </div>
        </template>

        <span class="font-size-md"> {{ textToDisplay }}</span>
    </v-tooltip>
</template>

<script>
export default {
    props: ['type', 'value', 'obj', 'isTopPurchasesPetfood', 'dataIsHomologousPeriod'],

    computed: {
        textToDisplay() {
            if (this.dataIsHomologousPeriod) {
                return this.$t('clientMenu.needsDates');
            }

            if (this.isTopPurchasesPetfood) {
                return this.$t('clientMenu.noConsolidation');
            }

            return this.$t('clientMenu.notWithAdvanced');
        },
    },

    methods: {
        onUpdate(items) {
            this.$emit('input', items);
        },
    },
};
</script>
